export default __webpack_public_path__ + "img/bg_consultation-f461bad12cef1dc7bed22ec9e6c1c4f7.png";